import {Directive, ElementRef, Input, OnChanges, Renderer2} from '@angular/core';

@Directive({
  selector: '[dcpJoinClasses]',
  standalone: true,
})
export class JoinClassesDirective implements OnChanges {
  @Input('dcpJoinClasses') classes!: string[];
  @Input() classesPrefix?: string;
  @Input() classesPostfix?: string;
  @Input() wide?: boolean;

  constructor(private renderer: Renderer2, private elementRef: ElementRef) {}

  ngOnChanges() {
    if (this.classes && this.classes.length) {
      Object.values(this.classes).forEach((item) => {
        this.renderer.addClass(
          this.elementRef.nativeElement,
          `${this.classesPrefix ?? ''}${item}${this.classesPostfix ?? ''}`
        );
      });
    }

    if (this.wide) {
      this.renderer.addClass(this.elementRef.nativeElement, 'wide');
    }
  }
}
